import { FfbbsiteGlobals } from '../directus';

export default function mapGlobalsToUrlImages(directusGlobals?: FfbbsiteGlobals) {
  return {
    socialCatchphrase: directusGlobals?.socials_catchphrase || '',
    socialItems: ((directusGlobals?.socials_items as Array<any>) || []).map(
      ({ image, title, url, image_dark }: any) => ({
        image,
        image_dark,
        title,
        url,
        external: true,
      }),
    ),
    footerCatchphrase: directusGlobals?.footer_catchphrase || '',
  };
}
